import React, { useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import copy from 'copy-to-clipboard';
import FileCopy from '@material-ui/icons/FileCopy';
import Divider from '@material-ui/core/Divider';
import {TableCell, TableContainer} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {uuidShortName, adaptCameraStatusValue} from '../../helpers';
import {Link} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const CamerasExpanded = (props) => {
  const [isViewDevice, setViewDevice] = useState(false);
  const [isViewCameraChannels, setViewCameraChannels] = useState(false);
  const [isViewVirtualCameras, setViewVirtualCameras] = useState(false);
  const [collapsedStates, setCollapsedStates] = useState(new Map())

  function row1 () {
    const devices = () => {
      const dataRow = [];
      dataRow.push({route: props.active_route, routeType: 'Active'});
      if(props.alternative_routes !== null && props.alternative_routes !== undefined)
        props.alternative_routes.forEach(route => dataRow.push({route: route, routeType: 'Backup'}));
      return dataRow;
    };
    const vcams = () => props.virtual_cameras?.map(item => ({uuid: item}));

    {isViewDevice ? dropDevice(devices()) : null}
    {isViewVirtualCameras ? dropVirtualCameras(vcams()) : null}

    {staticDevicesText('Devices/Routes', devices())}
    {staticText('Main Rtsp Url', props.MainRtsp, 'copy')}
    {staticText('Channels/Profiles', props.cameraRtspChannels.length, 'channels')}

    {isViewCameraChannels ? dropCameraChannels(props.cameraRtspChannels) : null}

    {staticVirtualCameraText('Virtual Cameras', props.virtual_cameras)}

    {staticText('Status', adaptCameraStatusValue(props.TestedStatus))}
    return (
      <>
        <List className="list-horizontal-flex">
          {staticText('Brand', props.cameraBrand)}
          {staticText('Model', props.cameraModel)}
          {staticText('Serial Number', props.serial_number)}

          {staticText('UUID', props.uuid)}
          {staticText('MAC', props.mac)}
          {staticText('IP Address', props.IpAddr)}

          {staticText('Port', props.IpPort)}
          {staticText('Hardware ID (HWid)', props.hardware_id)}
          {staticText('Firmware Version', props.firmware_version)}

          {staticText('Main Rtsp Url', props.MainRtsp, 'copy')}
          {staticText('User Name', props.userName)}
          {staticText('Password', props.password)}

          {staticText('Status', adaptCameraStatusValue(props.TestedStatus))}
          {staticDevicesText('Devices/Routes', devices())}
        </List>
      </>
    );
  }

  function devicesAndSlotsInformation() {
    let virtual_cameras = null
    if(Array.isArray(props.virtual_cameras) && props.virtual_cameras.length > 0 )
    {
      virtual_cameras = props.virtual_cameras.map((element) => {
        var rtspInfoMap = {upper: '-', lower: '-'}
        if(Array.isArray(element.rtsp_channels) && element.rtsp_channels.length > 0 )
        {
          var rtspProfile  = element.rtsp_channels.find(rtspProfile => rtspProfile.profileName === element.cameraAnalyzeRtspPreferred)
          if(rtspProfile) {
            let profileName = ''
            profileName += rtspProfile.profileName
            profileName += ': '
            profileName += rtspProfile.codec
            profileName += ', '
            profileName += rtspProfile.resolution
            profileName += ', '
            profileName += rtspProfile.fps
            rtspInfoMap =  {upper: profileName, lower: rtspProfile.rtspUrl}
          }
        }
        return {
          'Device': element.device_uuid,
          'Slot#': element.slot_index,
          'Label': element.label,
          'Channel/Profile': rtspInfoMap,
          'Virtual Camera(s)': element.uuid,
          'Multicast IP Address': props.dst_multicast_ip,
          'Multicast Port': props.dst_multicast_port
        }
      })
    }

    const headerNames = ['Device', 'Slot#', 'Label', 'Channel/Profile', 'Virtual Camera(s)', 'Multicast IP Address', 'Multicast Port'];

    const viewBody = function (item, index) {
      return (
        <React.Fragment>
          <TableRow key={index}>
            {createDefaultTableBodyCell(item['Device'])}
            {createDefaultTableBodyCell(item['Slot#'])}
            {createDefaultTableBodyCell(item['Label'])}
            {createTwoRowsTableBodyCell(item['Channel/Profile'])}
            {createCollapsibleTableBodyCell(item['Virtual Camera(s)'])}
            {createDefaultTableBodyCell(item['Multicast IP Address'])}
            {createDefaultTableBodyCell(item['Multicast Port'])}
          </TableRow>
          <TableRow>
            <TableCell colSpan={7}>
              <Collapse
                id={'collapse-' + item['Virtual Camera(s)']}
                hidden={!collapsedStates.get('collapse-' + item['Virtual Camera(s)'])}
                in={collapsedStates.get('collapse-' + item['Virtual Camera(s)'])}
              >
                {
                  vcamCollapsibleTable(getVcamData(item['Virtual Camera(s)']))
                }
              </Collapse>
            </TableCell>
          </TableRow>
        </React.Fragment>
      );
    }
    return createTable(headerNames, viewBody, virtual_cameras, null)
  }

  function getVcamData(vcamUuid) {
    return props.virtual_cameras.filter((item) => {
      return (item.uuid === vcamUuid)
    }).map((item) => {
      return {label: item.label,
        uuid: item.uuid,
        ewc_instance_name: item.ewc_instance_name,
        type: item.type}
    })
  }

  function staticDevicesText(label, values) {
    const params = {
      label,
      values: values.map(value => value.route),
      isSelected: isViewDevice,
      onclick: () => {
        setViewDevice(!isViewDevice);
        setViewCameraChannels(false);
        setViewVirtualCameras(false);
      }
    }
    return staticDropText(params);
  }

  function staticVirtualCameraText(label, values) {
    const params = {
      label,
      values,
      isSelected: isViewVirtualCameras,
      onclick: () => {
        setViewVirtualCameras(!isViewVirtualCameras);
        setViewCameraChannels(false);
        setViewDevice(false);
      }
    }
    return staticDropText(params);
  }

  function staticDropText(params) {
    const {label, values, isSelected, onclick} = params;
    const itemsCount = values.length > 1 ? `+${values.length - 1}` : '';
    if (values.length == 0) {
      return
    }

    const firstItemValue = values[0];
    if (firstItemValue == '' || firstItemValue == undefined) {
      return
    }
    return (
      <div>
        <ListItem selected={isSelected} classes={{ root: 'attributes', disabled: 'opaque' }}>
          <div style={{display: 'block', width: '100%'}}>
            <ListItemText primary={label} />
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <Tooltip title={firstItemValue}>
                <ListItemText primary={uuidShortName(firstItemValue)} style={{width: '100%'}} />
              </Tooltip>
              <ListItemText primary={itemsCount} />
            </div>
          </div>
          <IconButton style={{opacity: 1}} onClick={() => onclick()}>
            {isSelected ? <ExpandLess/> : <ExpandMore />}
          </IconButton>
        </ListItem>
        <Divider />
      </div>
    );
  }

  function staticText (label, value, cmd) {
    return (
      <div>
        <ListItem
          selected={cmd === 'channels' && isViewCameraChannels}
          classes={{ root: 'attributes', disabled: 'opaque' }} disabled={!cmd}
        >
          <ListItemText primary={label} secondary={value || '-'} />
          {
            cmd === 'copy'
              ? (
                <Tooltip title='Copy To Clipboard'>
                  <IconButton color='primary' style={{ opacity: 1 }} onClick={() => copy(value)}>
                    <FileCopy />
                  </IconButton>
                </Tooltip>
              )
              : null
          }
          {
            cmd === 'channels'
              ? (
                <IconButton
                  style={{opacity: 1}}
                  onClick={() => {
                    setViewCameraChannels(!isViewCameraChannels);
                    setViewVirtualCameras(false);
                    setViewDevice(false);
                  }}
                >
                  {isViewCameraChannels ? <ExpandLess/> : <ExpandMore />}
                </IconButton>
              )
              : null
          }
        </ListItem>
        <Divider />
      </div>
    );
  }

  function dropDevice(devices) {
    const headerNames = ['Route#', 'Device', 'Route Type'];
    const viewBody = function (item, index) {
      return (
        <TableRow key={index}>
          {createDefaultTableBodyCellIndex(index)}
          {createLinkTableBodyCell(item.route, '/devices')}
          {createDefaultTableBodyCell('test')}
        </TableRow>
      );
    }
    return createTable(headerNames, viewBody, devices);
  }

  function dropCameraChannels(dataRow) {
    const headerNames = ['Profile Name', 'Rtsp Url', 'Codec', 'Width', 'Height', 'FPS'];
    const viewBody = function (item, index) {
      return (
        <TableRow key={index}>
          {createDefaultTableBodyCell(item.profileName, '140px')}
          {createDefaultTableBodyCell(item.rtspUrl)}
          {createDefaultTableBodyCell(item.codec)}
          {createDefaultTableBodyCell(item.width)}
          {createDefaultTableBodyCell(item.height)}
          {createDefaultTableBodyCell(item.fps)}
        </TableRow>
      );
    }
    return createTable(headerNames, viewBody, dataRow);
  }

  function dropVirtualCameras(dataRow) {
    const headerNames = ['VCAM Label', 'VCAM UUID', 'EWC', 'Type'];
    const redirect = {path: '/vcam', filterColumn: 3, filterValue: props.uuid};
    const viewBody = function (item, index) {
      return (
        <TableRow key={index}>
          {createDefaultTableBodyCell(item.label)}
          {createDefaultTableBodyCell(item.uuid)}
          {createDefaultTableBodyCell(item.ewc)}
          {createDefaultTableBodyCell(item.type)}
        </TableRow>
      );
    }
    return createTable(headerNames, viewBody, dataRow, redirect);
  }

  function mapDataToTableBody(dataRow, viewBody, colSpanLength) {
    if(Array.isArray(dataRow) && dataRow.length > 0)
    {
      return dataRow.map((item, index) => viewBody(item, index))
    }
    return (
      <TableRow>
        <TableCell colSpan={colSpanLength} align="center">
          No Data to display
        </TableCell>
      </TableRow>
    );
  }

  function createTable(headerNames, viewBody, dataRow, redirect) {
    const buttons = () => {
      const {path, filterColumn, filterValue} = redirect;
      return (
        <div style={{textAlign: 'end', marginTop: 15}}>
          <Link to={path} onClick={() => props.updateRedirect({filterColumn, filterValue})}>
            <Button color="primary" variant="contained">EDIT</Button>
          </Link>
        </div>
      )
    };
    return(
      <div className='border' style={{minWidth: '100%'}}>
        <TableContainer>
          <Table>
            {createTableHeader(headerNames)}
            <TableBody style={{opacity: 0.5}}>
            </TableBody>
            <TableBody style={{opacity: 0.5}}>
              {mapDataToTableBody(dataRow, viewBody, headerNames.length)}
            </TableBody>
          </Table>
        </TableContainer>
        {redirect ? buttons() : null}
      </div>
    );
  }

  function createTableHeader(names) {
    return (
      <TableHead>
        <TableRow>
          {names.map(name => createTableHeaderCell(name))}
        </TableRow>
      </TableHead>
    );
  }

  function createTableHeaderCell(value) {
    return (
      <TableCell style={{fontWeight: 'bold', paddingBottom: '15px', paddingTop: '15px'}}>
        {value}
      </TableCell>
    );
  }

  function createDefaultTableBodyCell(value, minWidth) {
    const cellStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', minWidth: minWidth}
    return getTableCell(value, cellStyle);
  }

  function createCollapsibleTableBodyCell(value, minWidth) {
    const cellStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', minWidth: minWidth}
    return getTableCellWithCollapsible(value, cellStyle);
  }

  function createTwoRowsTableBodyCell(infoMap, minWidth) {
    const cellStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', minWidth: minWidth}
    const upperRowStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', minWidth: minWidth,}
    const lowerRowStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', minWidth: minWidth, 'font-size' : '12px'}
    return getTwoRowsTableCell(infoMap, upperRowStyle, lowerRowStyle, cellStyle);
  }

  function vcamCollapsibleTable(vcamData) {
    const headerNames = ['VCAM Label', 'VCAM UUID', 'EWC', 'Type'];
    const redirect = {path: '/vcam', filterColumn: 3, filterValue: props.uuid};
    const viewBody = function (item, index) {
      return (
        <TableRow key={index}>
          {createDefaultTableBodyCell(item.label)}
          {createDefaultTableBodyCell(item.uuid)}
          {createDefaultTableBodyCell(item.ewc_instance_name)}
          {createDefaultTableBodyCell(item.type)}
        </TableRow>
      );
    }
    return createTable(headerNames, viewBody, vcamData, redirect);
  }

  // // for index, increment by one
  function createDefaultTableBodyCellIndex(value, minWidth) {
    const cellStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', minWidth: minWidth}
    return (
      <TableCell style={cellStyle}>
        {value + 1}
      </TableCell>
    );
  }

  function createLinkTableBodyCell(value, path) {
    const cellStyle = {paddingBottom: '15px', paddingTop: '15px', borderBottom: 'none', color: 'red'}
    return (
      <Link to={path} underline="none" onClick={() => props.updateRedirect({id: value})}>
        {getTableCell(value, cellStyle)}
      </Link>
    );
  }

  function getTwoRowsTableCell(infoMap, upperRowStyle, lowerRowStyle, cellStyle) {
    return (
      <TableCell style={cellStyle}>
        <TableRow style={upperRowStyle}>
          {getCellValue(infoMap.upper)}
        </TableRow>
        <TableRow style={lowerRowStyle}>
          {getCellValue(infoMap.lower)}
        </TableRow>
      </TableCell>
    );
  }

  function getTableCell(value, style) {
    return (
      <TableCell style={style}>
        {getCellValue(value)}
      </TableCell>
    );
  }

  function setCollapsedState(collapse_id) {
    if(!collapsedStates.get(collapse_id)){
      setCollapsedStates(new Map(collapsedStates.set(collapse_id, true)));
    }else {
      setCollapsedStates(new Map(collapsedStates.set(collapse_id, false)));
    }
  }

  function getArrowIcon(collapse_id) {
    if(collapsedStates.get(collapse_id)) {
      return <KeyboardArrowUpIcon style={{ color: 'black' }}/>
    }
    return <KeyboardArrowDownIcon style={{ color: 'black' }}/>
  }

  function getTableCellWithCollapsible(value, style) {
    return (
      <TableCell align="center" style={style}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{'width': '80%', 'float':'left'}}>
            <Typography style={{maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
              {getCellValue(value)}
            </Typography>
          </div>
          <div style={{'width': '20%', 'float':'right'}}>
            <IconButton color='primary' style={{ opacity: 1 }} onClick={() => setCollapsedState('collapse-' + value)}>
              {getArrowIcon('collapse-' + value)}
            </IconButton>
          </div>
        </div>
      </TableCell>
    );
  }

  function getCellValue(value) {
    let finalValue;
    if(value !== undefined && value !== null && value !== '')
      finalValue = value;
    else
      finalValue = '-';
    return finalValue;
  }

  return (
    <>
      <div className='infrastructure-expanded'>
        <div className='border'>{row1()}</div>
        <div className='border' style={{marginTop: 15}}>{devicesAndSlotsInformation()}</div>
      </div>
    </>
  );
}

export default React.memo(CamerasExpanded);
